exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__table___3-lqN{border-collapse:collapse;width:100%;table-layout:fixed}.style__tableHead___2eK2K{color:#333;background-color:#f2f2f2;height:16px;font-weight:700;letter-spacing:.8px;border:1px solid #acacac;border-left:none;border-right:none}.style__tableRow___Hf4q_{border-bottom:.3px solid #acacac}.style__tableRow___Hf4q_.style__checked___CMqe-{background:#f9f1f1}.style__tableData___3T-Mt{padding:14px;font-size:11px;font-weight:300;text-align:center;letter-spacing:.8px;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:140px}.style__tableHead___2eK2K .style__tableData___3T-Mt{font-family:PlayfairDisplay-Bold;border:none;font-size:13px}.style__sortableHeader___4tH2Z{display:flex;justify-content:center;align-items:center;color:#333}", ""]);

// exports
exports.locals = {
	"table": "style__table___3-lqN",
	"tableHead": "style__tableHead___2eK2K",
	"tableRow": "style__tableRow___Hf4q_",
	"checked": "style__checked___CMqe-",
	"tableData": "style__tableData___3T-Mt",
	"sortableHeader": "style__sortableHeader___4tH2Z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/table/style.css
// module id = 712
// module chunks = 0